import { render } from "./NotificationSnackbar.html?vue&type=template&id=bbaa8fa8&ts=true&external"
import script from "./NotificationSnackbar.vue?vue&type=script&lang=ts"
export * from "./NotificationSnackbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__